import { Component, EventEmitter, Input, Output } from "@angular/core";

interface AssessmentQuestion {
  id: number;
  question: string;
  type: 'single' | 'multiple' | 'true_false';
  options: string[];
  correctAnswer: string | string[];
  points: number;
}

@Component({
  selector: "app-assessment",
  standalone: false,
  templateUrl: "./assessment.component.html",
  styleUrl: "./assessment.component.scss",
})
export class AssessmentComponent {

  @Input() document: any;

  @Output() close = new EventEmitter<void>();
  @Output() saved = new EventEmitter<any>();

  assessmentTitle = '';
  description = '';

  duration = 30;
  passingScore = 70;

  showQuestionForm = false;

  editingQuestionIndex: number | null = null;

  question: AssessmentQuestion = this.createEmptyQuestion();

  questions: AssessmentQuestion[] = [];

  private createEmptyQuestion(): AssessmentQuestion {
    return {
      id: Date.now(),
      question: '',
      type: 'single',
      options: ['', ''],
      correctAnswer: '',
      points: 1
    };
  }

  openQuestionForm(): void {
    this.editingQuestionIndex = null;
    this.question = this.createEmptyQuestion();
    this.showQuestionForm = true;
  }

  editQuestion(index: number): void {
    this.editingQuestionIndex = index;

    this.question = {
      ...this.questions[index],
      options: [...this.questions[index].options]
    };

    this.showQuestionForm = true;
  }

  removeQuestion(index: number): void {
    this.questions.splice(index, 1);
  }

  addOption(): void {
    this.question.options.push('');
  }

  removeOption(index: number): void {
    if (this.question.options.length <= 2) {
      return;
    }

    this.question.options.splice(index, 1);
  }

  saveQuestion(): void {
    if (!this.question.question.trim()) {
      return;
    }

    this.question.options = this.question.options
      .map(option => option.trim())
      .filter(option => option);

    if (this.editingQuestionIndex !== null) {
      this.questions[this.editingQuestionIndex] = {
        ...this.question
      };
    } else {
      this.questions.push({
        ...this.question,
        id: Date.now()
      });
    }

    this.showQuestionForm = false;
    this.question = this.createEmptyQuestion();
    this.editingQuestionIndex = null;
  }

  saveAssessment(): void {

    if (!this.assessmentTitle.trim()) {
      return;
    }

    const assessment = {
      document_id: this.document?.message_id,
      group_id: this.document?.group_id,

      title: this.assessmentTitle,
      description: this.description,

      duration: this.duration,
      passing_score: this.passingScore,

      questions: this.questions
    };

    console.log('Assessment payload:', assessment);

    this.saved.emit(assessment);
  }

  closeModal(): void {
    this.close.emit();
  }
}
